import { Stack } from "@mui/material"
import Kpi from "../../Tools/Kpi"
import { txt } from "../../../services/translation";

export default function Kpis({data}){

    const color = data.category?.color;

    return <Stack spacing={1}>
    
        <Stack direction='row' flexWrap='wrap'>

            <Kpi 
                title={data.enrollmentsCount?.toLocaleString()}
                caption={txt('enrollmentsCaption')}
                icon='school'
                color={color}
                sx={{mr: 1, mb: 1}}
            />

            <Kpi 
                title={data.completion?.toLocaleString()}
                unit={'%'}
                caption={txt('averageCompletionCaption')}
                icon='check'
                color={color}
                sx={{mr: 1, mb: 1}}
            />

        </Stack>

    </Stack>

}